<div class="layout">
  <mat-toolbar class="toolbar">
    <app-header></app-header>
  </mat-toolbar>

  @if (apiConnection.error() || userError()) {
    <div class="api-status api-status--error" role="alert">
      <mat-icon aria-hidden="true">cloud_off</mat-icon>
      <span>{{ apiConnection.error() || userError() }}</span>
      <button mat-button type="button" (click)="retryConnection()" [disabled]="apiConnection.loading()">Reintentar</button>
    </div>
  }
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>

  <footer class="version-footer">
    @if (feedbackAccess.canAccess()) {
      <div class="footer-tasks feedback-controls"><button mat-icon-button type="button" (click)="newTask()" aria-label="Crear una tarea" matTooltip="Crear una tarea"><mat-icon>add_task</mat-icon></button><a mat-button routerLink="/feedback">Tareas del equipo</a></div>
    }
    <span>{{ versionFooterText() }}</span>
  </footer>
</div>
